import httpService from '@/utils/request'
import { contextPath } from '@/config/'

// 列表
export const getSpiderMqList = (params) => {
  return httpService({
    url: contextPath + '/spiderMq/info',
    method: 'get',
    params
  })
}

// 新增
export const addSpiderMq = (data) => {
  return httpService({
    url: contextPath + '/spiderMq/item',
    method: 'post',
    data
  })
}

// 详情
export const getSpiderMq = (data) => {
  return httpService({
    url: contextPath + '/spiderMq/item',
    method: 'get',
    data
  })
}

// 编辑
export const editSpiderMq = (data) => {
  return httpService({
    url: contextPath + '/spiderMq/item',
    method: 'put',
    data
  })
}

// 删除
export const deleteSpiderMq = (params) => {
  return httpService({
    url: contextPath + '/spiderMq/item',
    method: 'delete',
    params
  })
}

// 修改状态
export const editSpiderMqStatus = (data) => {
  return httpService({
    url: contextPath + '/spiderMq/item/updateStatus',
    method: 'put',
    data
  })
}
